// ============================================================================
// FSA NARRATIVE COMPONENT SERVICE (ADR-0005)
// ============================================================================

import { get, post } from '../../client/axiosClient';
import { fsaNarrativeEndpoints } from '../../endpoints/fsa/fsaNarratives.endpoints';
import type { ApiResponse, ID } from '../../types';
import type {
  EngagementNarrativeStatus,
  NarrativeComponent,
  UpdateNarrativePinRequest,
} from '../../types/fsa/narrative.types';

class FsaNarrativeService {
  /** All narrative component versions installed on this tenant. */
  async listInstalled(): Promise<ApiResponse<NarrativeComponent[]>> {
    const r = await get<ApiResponse<NarrativeComponent[]>>(fsaNarrativeEndpoints.installed());
    return r.data;
  }

  /** One installed component with its full body — exact version, or latest installed when omitted. */
  async getComponent(code: string, version?: number | null): Promise<ApiResponse<NarrativeComponent>> {
    const url = fsaNarrativeEndpoints.component(code)
      + (version != null ? `?version=${version}` : '');
    const r = await get<ApiResponse<NarrativeComponent>>(url);
    return r.data;
  }

  /** Per-slot pin status (pinned vs latest) for one engagement. */
  async engagementStatus(engagementId: ID): Promise<ApiResponse<EngagementNarrativeStatus[]>> {
    const r = await get<ApiResponse<EngagementNarrativeStatus[]>>(
      fsaNarrativeEndpoints.engagementStatus(engagementId),
    );
    return r.data;
  }

  /** Re-pin one narrative slot to the target (or latest installed) version. */
  async updatePin(
    engagementId: ID,
    request: UpdateNarrativePinRequest,
  ): Promise<ApiResponse<EngagementNarrativeStatus>> {
    const r = await post<ApiResponse<EngagementNarrativeStatus>>(
      fsaNarrativeEndpoints.updatePin(engagementId), request,
    );
    return r.data;
  }
}

export const fsaNarrativeService = new FsaNarrativeService();
export default fsaNarrativeService;
